<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col align="center" cols="12" sm="8" md="4">
        <v-card>
        <v-form @submit="login" v-on:submit.prevent>
          <v-card-text>
              <v-text-field
                autofocus
                placeholder=" "
                label="Login"
                name="login"
                v-model="email"
                prepend-icon="person"
                type="text"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                v-model="password"
                placeholder=" "
                prepend-icon="lock"
                type="password"
              />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" type="submit">Login</v-btn>
          </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
 <v-snackbar
      v-model="snackbar"
      color="accent"
      :timeout=5000
      :top="true"
    >
      {{ errorMessage }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Chiudi
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<style scoped="true">
h3{
  width:100%;
  margin-bottom: 1rem;
}
</style>
<script>
import api from '@/api'
export default {
  name: "UserLogin",
  data: () => ({
    errorMessage: null,
    snackbar: false,
    email: '',
    password: ''
  }),
  methods: {
    async login () {
      try {
        const user = await api.login({
          email: this.email,
          password: this.password
        })
        localStorage.setItem('user', user);
        this.$store.commit('login')
        this.$router.push('dashboard')
      } catch (error){
        this.errorMessage = error.data
        this.snackbar = true
      }
    }
  }
};
</script>
